export const forgotPasswordFormConstantsEN = {
  forgotPasswordFormTitle: 'Forgot your password?',
  forgotPasswordFormSubTitle: 'We will send a code to reset your password to the email associated with an existing account.',
  forgotPasswordFormButtonText: 'Reset Password',
  forgotPasswordFeildLabel: 'Email',
  resetPasswordEmailSentSnackBar: 'Email has been sent !',
};

export default forgotPasswordFormConstantsEN;
